/* global axios */
import ApiClient from './ApiClient';

class ClaudiaTakeoversAPI extends ApiClient {
  constructor() {
    super('claudia/takeovers', { accountScoped: true });
  }

  // Sends the ENTIRE conversation_ids snapshot in one request — the backend
  // enqueues a Claudia::BulkTakeoverJob and returns { batch_id } immediately
  // (202), it does not execute inline any more. No client-side chunking.
  bulk(conversationIds) {
    return axios.post(`${this.url}/bulk`, {
      conversation_ids: conversationIds,
    });
  }
}

export default new ClaudiaTakeoversAPI();
